<template>
  <a-card :bordered="false">
    <!-- 検索区域-begin -->
    <search-area
      ref="SearchArea"
      :rowKeySize="this.selectedRowKeys.length"
      batchType="3"
      parent="AdminRuntimeModal"
      @searchQuery="searchQuery(false, false)"
      @handleExport="handleExport()"
      @updateQueryParam="updateQueryParam"
      @addTaskIdentity="addTaskIdentity"
      @addTaskVariableLocal="addTaskVariableLocal"
      @batchAction="batchAction"
    ></search-area>
    <!-- 検索区域-end -->

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        class="action"
        rowKey="processInstanceId"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        @change="handleTableChange"
        tableLayout="auto"
      >
        <!-- 申請時間 -->
        <div slot="startDate" slot-scope="text, record">
          <span>
            {{ moment(record.startDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.startDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <!-- 最近更新時間 -->
        <div slot="endDate" slot-scope="text, record">
          <span>
            {{ moment(record.endDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.endDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <!-- タスク -->
        <div slot="task" slot-scope="text, record">
          <TaskColumn :record="record" :key="refresh"></TaskColumn>
        </div>

        <!-- 処理者 -->
        <div slot="candidate" slot-scope="text, record" class="show-title">
          <TaskColumn :record="record" colType="candidate" :key="refresh"></TaskColumn>
        </div>

        <!-- ステータス -->
        <div slot="taskStatus" slot-scope="text, record">
          <a-tag color="green" v-if="record.taskStatus == 'disp.flow.save'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag color="purple" v-if="record.taskStatus == 'disp.flow.applyWait'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag color="orange" v-else-if="record.taskStatus == 'disp.flow.approveWait'">{{
            $t(record.taskStatus)
          }}</a-tag>
          <a-tag color="cyan" v-else-if="record.taskStatus == 'disp.flow.keep'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag color="blue" v-else-if="record.taskStatus == 'disp.flow.freeze'">{{ $t(record.taskStatus) }}</a-tag>
        </div>

        <div slot="action" slot-scope="text, record" style="width: 100%; text-align: left">
          <div v-if="record.keepFlag">
            <a-popconfirm
              :title="$t('msg.flow.confirm.keepCancel')"
              @confirm="() => handleAdminCancelKeep(record.processInstanceId, record.endDateTimestamp)"
            >
              <a>{{ $t('disp.flow.keepCancel') }}</a>
            </a-popconfirm>

            <a-divider type="vertical" />
            <a @click="handleOpen(record)">{{ $t('disp.flow.detail') }}</a>

            <a-divider type="vertical" />
            <a @click="handleHistory(record.processInstanceId, record.processDefinitionName)">{{
              $t('disp.flow.history')
            }}</a>
          </div>

          <div v-else-if="record.freezeFlag">
            <a-popconfirm
              :title="$t('msg.flow.confirm.unfreeze')"
              @confirm="() => handleUnfreeze(record.processInstanceId, record.endDateTimestamp)"
            >
              <a>{{ $t('disp.flow.unfreeze') }}</a>
            </a-popconfirm>

            <a-divider type="vertical" />
            <a @click="handleOpen(record)">{{ $t('disp.flow.detail') }}</a>

            <a-divider type="vertical" />
            <a @click="handleHistory(record.processInstanceId, record.processDefinitionName)">{{
              $t('disp.flow.history')
            }}</a>
          </div>

          <div v-else>
            <!-- 委派 -->
            <template v-if="record.taskStatus == 'disp.flow.approveWait'">
              <a @click="handleAppoint(record)">委派</a>
              <a-divider type="vertical" />
            </template>

            <a-popconfirm
              :title="$t('msg.flow.confirm.freeze')"
              @confirm="() => handleFreeze(record.processInstanceId, record.endDateTimestamp)"
            >
              <a>{{ $t('disp.flow.freeze') }}</a>
            </a-popconfirm>

            <a-divider type="vertical" />
            <a-popconfirm
              :title="$t('msg.flow.confirm.cancel')"
              @confirm="() => handleCancel(record.processInstanceId, record.endDateTimestamp)"
            >
              <a>{{ $t('disp.flow.cancel') }}</a>
            </a-popconfirm>

            <a-divider type="vertical" />
            <a @click="handleOpen(record)">{{ $t('disp.flow.detail') }}</a>

            <a-divider type="vertical" />
            <a @click="handleHistory(record.processInstanceId, record.processDefinitionName)">{{
              $t('disp.flow.history')
            }}</a>
          </div>
        </div>
      </a-table>
    </div>
    <!-- table区域-end -->

    <track-modal ref="TrackModal"></track-modal>

    <!-- 申請モーダル：申請フォームを載せる -->
    <apply-modal ref="ApplyModal"></apply-modal>

    <!-- コメントモーダル：コメントフォームを載せる -->
    <comment-modal ref="CommentModal" @ok="searchQuery(false, false)"></comment-modal>

    <AppointModal ref="AppointModal" @emit="searchQuery(true, false)"></AppointModal>
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { flowMixin } from '@/mixins/flowMixin'
import { putAction, postAction, getAction } from '@/api/manage'
import TrackModal from './TrackModal'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import SearchArea from './SearchArea'
import CommentModal from '@/views/k00/k0011/modules/CommentModal'
import AppointModal from '@/views/k00/k0011/modules/AppointModal'
import TaskColumn from '@/views/k00/k0011/modules/TaskColumn'

export default {
  name: 'AdminRuntimeModal',
  mixins: [tableMixin, flowMixin],
  components: {
    TrackModal,
    JDictSelectTag,
    SearchArea,
    CommentModal,
    AppointModal,
    TaskColumn,
  },
  data() {
    return {
      description: '申請案件一覧・進行中',
      parent: {},
      showLoadingBySearch: true,
      disableMixinSearchQuery: true,
      refresh: Date.parse(new Date()),
      // テーブルタイトル
      columns: [
        {
          title: this.$t('disp.flow.applyId'),
          //align: 'center',
          //width: 91,
          //fixed: 'left',
          dataIndex: 'processInstanceId',
          customRender: this.renderProcessInstanceId,
        },
        {
          title: this.renderApplyNameHeader,
          dataIndex: 'processDefinitionName',
          customRender: this.renderApplyName,
        },
        {
          title: this.$t('disp.flow.starter'),
          align: 'center',
          width: 91,
          customRender: this.renderStarter,
        },
        {
          title: this.$t('disp.flow.starterOrg'),
          align: 'left',
          // width: 180,
          dataIndex: 'starterDepartName',
          customRender: this.renderDepartName,
        },
        {
          title: this.$t('disp.flow.startDate'),
          align: 'left',
          dataIndex: 'startDate',
          //scopedSlots: { customRender: 'startDate' },
          customRender: this.renderDate,
        },
        {
          title: this.$t('disp.flow.lastUpdateDate'),
          align: 'left',
          dataIndex: 'endDate',
          //scopedSlots: { customRender: 'endDate' },
          customRender: this.renderDate,
        },
        {
          title: this.$t('disp.flow.task'),
          scopedSlots: { customRender: 'task' },
        },
        {
          title: this.$t('disp.flow.candidate'),
          align: 'center',
          width: 91,
          //fixed: 'right',
          scopedSlots: { customRender: 'candidate' },
        },
        {
          title: this.$t('disp.status'),
          align: 'center',
          width: 91,
          //fixed: 'right',
          scopedSlots: { customRender: 'taskStatus' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          //width: 190,
          //fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/flow/adminRuntime/list',
        addTaskIdentity: '/flow/adminRuntime/addTaskIdentity',
        addTaskVariableLocal: '/flow/adminRuntime/addTaskVariableLocal',
        freeze: '/flow/processInstance/freeze',
        unfreeze: '/flow/processInstance/unfreeze',
        cancel: '/flow/processInstance/cancel',
        adminCancelKeep: '/flow/processInstance/adminCancelKeep',
      },
    }
  },
  watch: {
    '$route.params.name': {
      handler(newVal, oldVal) {
        if (this.$refs.SearchArea) {
          if (newVal) {
            this.parent.activeKey = 1
            this.$refs.SearchArea.$set(this.$refs.SearchArea.queryParam, 'processDefinitionName', newVal)
            this.queryParam.processDefinitionName = newVal
            //this.queryParam.modelId = this.$route.params.modelId
            this.searchQuery(false, false)

            // queryParamをクリアする
            this.$router.push({
              path: this.$route.path,
              query: Object.assign({}, this.$route.query, { _: +new Date() }),
            })
          }
          //else if (this.$route.path == '/blaze-sys/k00/k0011/ProcessInstanceManage') {
          //  this.searchQuery(false, false)
          //}
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    let name = this.$route.params.name
    if (name) {
      this.$refs.SearchArea.$set(this.$refs.SearchArea.queryParam, 'processDefinitionName', name)
      this.queryParam.processDefinitionName = name
      //this.queryParam.modelId = this.$route.params.modelId
      this.searchQuery(false, false)

      // queryParamをクリアする
      this.$router.push({
        path: this.$route.path,
        query: Object.assign({}, this.$route.query, { _: +new Date() }),
      })
    } else {
      this.searchQuery(false, false)
    }
  },
  methods: {
    updateQueryParam() {
      this.queryParam = this.$refs.SearchArea ? this.$refs.SearchArea.queryParam : {}
    },
    tagColor(task) {
      if (task.taskActive) {
        return 'blue'
      } else {
        return 'blue'
      }
    },
    tagName(user) {
      return user.realname
    },
    handleExport() {
      this.queryParam.isExport = true

      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      getAction(this.url.list, this.queryParam)
        .then((res) => {
          if (res.success) {
            // 处理成功
            downloadFile(res.message)
            this.$message.success(this.$t('msg.operation.success'))
          }
        })
        .finally(() => {
          this.loading = false
          this.queryParam.isExport = false
        })
    },
    addTaskIdentity() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }
      getAction(this.url.addTaskIdentity, null)
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t('msg.operation.success'))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    addTaskVariableLocal() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }
      getAction(this.url.addTaskVariableLocal, null)
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t('msg.operation.success'))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleOpen(record) {
      // 0 下記以外
      // 1 申請ポータル
      // 2 一時保存一覧
      // 3 未処理一覧
      // 4 処理済一覧・進行中案件 or 申請案件一覧・進行中案件
      // 5 処理済一覧・終了案件 or 申請案件一覧・終了案件
      // 6 処理済一覧・非活性案件
      this.$refs.ApplyModal.popupFrom = '4'

      this.$refs.ApplyModal.title = record.processDefinitionName
      this.$refs.ApplyModal.component = record.component
      this.$refs.ApplyModal.procInstId = record.processInstanceId
      this.$refs.ApplyModal.taskId = record.id
      this.$refs.ApplyModal.status = record.taskStatus

      this.$refs.ApplyModal.handleOpen()
    },
    handleHistory(processInstanceId, title) {
      this.$refs.TrackModal.open(processInstanceId, title)
    },
    handleFreeze(processInstanceId, endDateTimestamp) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.freeze, { processInstanceId: processInstanceId, endDateTimestamp: endDateTimestamp })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleUnfreeze(processInstanceId, endDateTimestamp) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.unfreeze, { processInstanceId: processInstanceId, endDateTimestamp: endDateTimestamp })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleCancel(processInstanceId, endDateTimestamp) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.cancel, { processInstanceId: processInstanceId, endDateTimestamp: endDateTimestamp })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleAdminCancelKeep(processInstanceId, endDateTimestamp) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.adminCancelKeep, { processInstanceId: processInstanceId, endDateTimestamp: endDateTimestamp })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    callbackAfterSearchQuery() {
      this.refresh++
    },
    handleAppoint(record) {
      this.$refs.AppointModal.handleOpen(record, true)
    },
  },
}
</script>
